import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  quizTitle: {
    fontSize: '32px !important',
    textAlign: 'left'
  },
  questionTitle: {
    textAlign: 'left',
    fontSize: '20px !important'
  }
}))
